import React, { useState } from "react";
import AppDialog, {
  DialogFooter,
  PrimaryAction,
  TextButton,
} from "../../../../../v2/components/molecules/dialog";
import { DialogContent, Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AppLogger from "../../../../../v2/utils/logger";
import AccountPageDomain from "../../../../../v2/features/account-page";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setAppSnackNotification } from "../../../../../v2/store/actions/application";
import { getPricingPackageNameById } from "../../../../../v2/utils/data-generator";
import Constants, { APP_LANG } from "../../../../../v2/config/constant";
import Config from "../../../../../v2/config";
import {
  getAuthUserAccount,
  getAuthUserProfile,
} from "../../../../../v2/features/application";

const { LANKA_COUNTRY_CODE } = Constants;
const { SUBSCRIPTION_RENEWAL_DISCOUNT_PERCENTAGE } = Config;

const RetryPaymentModal = ({
  showModal,
  onCloseModal,
  setShowConfirmDialog,
}) => {
  const { t, i18n } = useTranslation();
  const { authProfile } = useSelector((state) => state.application);
  const dispatch = useDispatch();

  const [processing, setProcessing] = useState(false);

  const isSriLankan =
    authProfile.personalInfo?.residentCountry?.code === LANKA_COUNTRY_CODE;

  const amount = isSriLankan
    ? authProfile.pricingTier?.amountLKR ?? 0
    : authProfile.pricingTier?.amountUSD ?? 0;

  const amountAferDiscount = (
    amount -
    (amount * SUBSCRIPTION_RENEWAL_DISCOUNT_PERCENTAGE) / 100
  ).toFixed(2);

  const packageAmount = isSriLankan
    ? `LKR ${amountAferDiscount}`
    : `USD ${amountAferDiscount}`;

  const onClickPayNow = async () => {
    try {
      setProcessing(true);
      const response = await AccountPageDomain.chargeSubscription({
        postId: authProfile.id,
      });
      if (!response || !response.success) {
        dispatch(
          setAppSnackNotification({
            severity: "error",
            message: t("accountPage.paymentFailedAlert"),
          })
        );
        return;
      }
      dispatch(
        setAppSnackNotification({
          message: t("accountPage.paymentRetrySuccessAlert"),
        })
      );
      dispatch(getAuthUserAccount());
      dispatch(getAuthUserProfile());
      setShowConfirmDialog(false);
    } catch (error) {
      dispatch(
        setAppSnackNotification({
          severity: "error",
          message: t("accountPage.paymentRetryFailedAlert"),
        })
      );
      AppLogger.exception(error);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <AppDialog
      showModal={showModal}
      initialized={true}
      onCloseModal={onCloseModal}
      title={t("accountPage.retryPaymentModalTitle")}
    >
      <DialogContent>
        <Grid
          item
          container
          direction="column"
          className="payment-retry-modal-content row-gap-16 margin-top-8"
        >
          <Typography
            variant="body2"
            className={`${i18n.language === APP_LANG.SI && "font-size-12"}`}
          >
            {t("accountPage.paymentRetryModalNotice")}
          </Typography>

          <Grid
            item
            container
            direction="column"
            className="payment-info-section row-gap-4"
          >
            <Typography
              variant="body2"
              className="font-weight-600 margin-bottom-8"
            >
              {t("accountPage.packageInfo")}
            </Typography>
            <Grid item container justifyContent="space-between">
              <Typography variant="caption">
                {t("pricing.packageName")}
              </Typography>
              <Typography variant="caption">
                {getPricingPackageNameById(authProfile.pricingTier?.id)}
              </Typography>
            </Grid>

            <Grid item container justifyContent="space-between">
              <Typography variant="caption">
                {t("payment.packageAmount")}
              </Typography>
              <Typography variant="caption">{packageAmount}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogFooter>
        <PrimaryAction
          label="Retry Payment"
          fullWidth={true}
          processing={processing}
          onClick={() => onClickPayNow()}
        />
        <TextButton
          label="Cancel"
          fullWidth={true}
          onClick={() => onCloseModal()}
        />
      </DialogFooter>
    </AppDialog>
  );
};

export default RetryPaymentModal;
